import { Autocomplete } from 'components';
import React, { useEffect, useState } from 'react';
import DistrictServices from "services/DistrictServices";


/**
 * AutocompleteField - Themed, reusable autocomplete component with validation, using TextValidator as input.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */

const District = ({
    name,
    label,
    value,
    onChange,
    filter,
    options: propOptions,
    required = false,
    validators = [],
    errorMessages = [],
}) => {

    const [data, setData] = useState(propOptions || []);
    const [filters, setFilters] = useState({ ...(filter || {}), limit: 100, search: null, status: 'Active' });



    useEffect(() => {
        if (propOptions && Array.isArray(propOptions) && propOptions.length > 0) {
            setData(propOptions);
            return;
        }

        const fetchData = async () => {
            try {
                const [res] = await Promise.all([
                    DistrictServices.getAll({ ...filters }),
                ]);
                const branches = res?.data?.view?.data || [];
                const districts = branches
                    .map((b) => b.district)
                    .filter((d) => d && d.id != null);
                const uniqueDistricts = Array.from(
                    new Map(districts.map((d) => [d.id, d])).values()
                ).map((d) => ({ id: d.id, name: d.name }));
                setData(uniqueDistricts);
            } catch (error) {
            }
        };
        fetchData();
    }, [filters, propOptions]);



    return (
        <div>
            <Autocomplete
                name={name}
                label={label}
                value={(() => {
                    const valueId = value && typeof value === 'object' ? value.id : value;
                    let found = data.find((item) => item.id === valueId);
                    if (!found && typeof value === 'string') {
                        found = data.find((item) => item.name === value);
                    }
                    return found || null;
                })()}
                onChange={(event, newValue) => {
                    if (onChange) onChange(event, newValue);
                }}
                isOptionEqualToValue={(option, val) => {
                    const valId = val && typeof val === 'object' ? val.id : val;
                    if (option && option.id != null && option.id === valId) return true;
                    if (typeof val === 'string' && option && option.name === val) return true;
                    return false;
                }}
                options={data}
                getOptionLabel={(option) => (option && option.name) || ''}
                textInputOnChange={(e) => {
                    setFilters({ ...filters, search: e.target.value })
                }}
                required={required}
                validators={validators}
                errorMessages={errorMessages}
            />
        </div>
    );
};

export default District  ;
